import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const c = useContent();
  const f = c.footer;
  const logo = c.site.logo;
  return (
    <footer data-testid="site-footer" className="bg-ink border-t border-white/10 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div>
            <p className="flex items-center gap-3 font-display text-2xl font-extrabold tracking-tight text-white">
              <img src={logo} alt="PRC Remit" className="h-10 w-10 object-contain" />
              PRC<span className="text-gold"> REMIT</span>
            </p>
            <p className="mt-4 text-sm font-light text-white/50 whitespace-nowrap leading-relaxed">
              {f.tagline}
            </p>
          </div>
          <div className="text-sm text-white/50 space-y-2">
            {f.lines.map((l, i) => (
              <p key={i}>{l}</p>
            ))}
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <p className="text-xs text-white/30">© 2026 PRC Remit株式会社. All rights reserved.</p>
          <Link to="/admin/login" data-testid="admin-link" className="text-xs text-white/30 hover:text-gold transition-colors">
            管理者ログイン
          </Link>
        </div>
      </div>
    </footer>
  );
};
